import { render, staticRenderFns } from "./ImageBlockLayout.vue?vue&type=template&id=1a467918"
import script from "./ImageBlockLayout.vue?vue&type=script&lang=js"
export * from "./ImageBlockLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports